import React from "react";
import GuideLayout from "../../components/layout/GuideLayout";
import Section from "../../components/layout/Section";
import Subheader from "../../components/layout/Subheader";
import {
  Typography,
  Link,
  Box
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const June2026 = () => {
  const theme = useTheme();

  return (
    <GuideLayout sections={[]}>
      <Section id="intro" title="Happy One Year!">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          June 2026 Update
        </Typography>
        <Typography paragraph>
          Let's celebrate our upcoming one year anniversary as a value guide! Time just flies doesn't it? June 23rd marks our official birthday, and we have some exciting news to share!
        </Typography>

        <Subheader title="Userscript Update" />

        <Typography paragraph>
          TNT updated the layout for closets and SDB recently. Our <Link href="/userscript" sx={{ color: theme.palette.primary.main }}>userscript</Link> has been updated so it works on the new layouts! If you're using our userscript, make sure you're on the updated version. Displayed values on all pages will also link to Stylisher search results, so you can easily access trade history with just one click.
        </Typography>

        <Box sx={{ textAlign: "center" }}>
          {/* eslint-disable-next-line */}
          <img src={require('../../assets/userscript_sdb_example.png')} alt="example of the userscript on the new sdb" style={{ maxWidth: "300px", borderRadius: 8, marginBottom: 10 }} />
        </Box>

        <Subheader title="How a Value Guide Works" />
        <Typography paragraph>
          Our main resource here at Stylisher is our Lebron value guide. We've published this article to explain
          <Link href="/articles/how-a-value-guide-works" sx={{ color: theme.palette.primary.main }}> how a value guide works</Link> and to clear up some misconceptions we've seen floating around. It also covers why personal values are important and how they're used in value guides like ours. We also posted some of our internal processes and guidelines for better transparency on how we operate, especially with the new addition of the key events feature.
        </Typography>

        <Subheader title="Key Events" />
        <Typography paragraph>
          When you search an item on this website, it might have some key events listed! We are now starting to track certain rereleases and events, namely ones that are likely to affect an item's value. This is not meant to be a full release history, but rather helpful extended notes to consider so it's easier for everyone to make informed trades. Keep in mind that these events are managed manually by team members, so think of this more of an editor's pick! We've retroactively added key events for this year with the cutoff date being January 1, 2026. For more information, visit this <Link href="/articles/how-a-value-guide-works#key-events" sx={{ color: theme.palette.primary.main }}> this section</Link>.
        </Typography>

        <Box sx={{ textAlign: "center" }}>
          {/* eslint-disable-next-line */}
          <img src={require('../../assets/key_events_example.png')} alt="example of an item search with key events" style={{ maxWidth: "500px", borderRadius: 8, marginBottom: 10 }} />
        </Box>

        <Subheader title="Miscellaneous NC Knowledge" />
        <Typography paragraph>
          There are some NC things that just don't seem to fit anywhere, so we've also started a <Link href="/articles/misc-nc-knowledge" sx={{ color: theme.palette.primary.main }}>Miscellaneous NC Knowledge</Link> page. It's fairly short with just random NC things like schedules and whatnot. It's like our catch-all for info that may be helpful for NC traders, and we'll edit if we think of more!
        </Typography>

        <Subheader title="One Year Celebration!" />
        <Typography paragraph>
          To commemorate our first anniversary, we've created a <Link href="/articles/anniversary-nc-quiz" sx={{ color: theme.palette.primary.main }}>fun quiz</Link> to showcase some stats and fun facts about what we've done over this past year! Take a look to find out what items have been traded a lot and give us your best guesses!
        </Typography>

        <Typography paragraph>
          The festivities don't stop there! We appreciate our reporting regulars, so for our top 10 traders, someone from our team will be contacting you in the next week to send you a gift. We're also hosting some general giveaways open to everyone in our <Link href="/contact" sx={{ color: theme.palette.primary.main }}>discord server</Link> so be sure to join for more info on scheduling and entering. Our team will be giving out <Link href="/articles/bfgbc" sx={{ color: theme.palette.primary.main }}>BFGBCs</Link>, reg GBCs, cookies, and more! These events will take place over the course of two weeks, leading up to our anniversary on the 23rd so come celebrate with us!
        </Typography>

        <Typography paragraph>
          Last but certainly not least, we want to give a big shoutout to everyone who contributes and supports our project. Whether that's reporting your trades, encouraging others to report trades, making a donation, or even just reading through our guides, we appreciate your support. Thank you for your patience when our team was new and learning to get the hang of things, and many thanks for a great first year. We hope we've done well to serve the community and we look forward to another fantastic year! :)
        </Typography>

        <Typography
          variant="caption"
        >
          If you enjoy using the Stylisher resources and would like to contribute to keeping our project up, please visit our <Link href="/support" sx={{ color: theme.palette.primary.main }}>Supporting Stylisher</Link> page!
        </Typography>
      </Section>

    </GuideLayout>
  );
};

export default June2026;
